import styled, { keyframes } from 'styled-components';
import {
  GRUNDFOS_BLUE,
  ATTENTION_BLUE,
  BLUE1,
  BLUE2,
  BLUE3,
} from '../../../constants/colors';
import { FONT_FAMILY, FONT_SIZE } from '../../../constants/fonts';
import { MEDIA } from '../../../constants/breakpoints';

export const AgentFinder = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 560px;
  margin: 0 auto;
`;

export const AgentFinder__Header = styled.p`
  color: ${GRUNDFOS_BLUE};
  font-family: ${FONT_FAMILY.SEMI_BOLD};
  font-size: ${FONT_SIZE.LARGE};
  margin: 0 0 6px 0;
  text-align: center;

  ${MEDIA.MOBILE} {
    font-size: ${FONT_SIZE.MEDIUM};
  }
`;

export const AgentFinder__Subtext = styled.p`
  color: ${BLUE3};
  font-family: ${FONT_FAMILY.REGULAR};
  font-size: ${FONT_SIZE.SMALL};
  margin: 0 0 16px 0;
  text-align: center;
  line-height: 1.4;
`;

export const AgentFinder__InputRow = styled.form`
  display: flex;
  gap: 8px;
  width: 100%;
`;

export const AgentFinder__Input = styled.input`
  flex: 1;
  padding: 12px 16px;
  border: 2px solid ${BLUE2};
  border-radius: 12px;
  font-family: ${FONT_FAMILY.REGULAR};
  font-size: ${FONT_SIZE.MEDIUM};
  color: ${GRUNDFOS_BLUE};
  background: white;
  outline: none;
  transition: border-color 0.2s ease;

  &::placeholder {
    color: ${BLUE3};
  }

  &:focus {
    border-color: ${ATTENTION_BLUE};
  }

  ${MEDIA.MOBILE} {
    font-size: ${FONT_SIZE.SMALL};
    padding: 10px 14px;
  }
`;

export const AgentFinder__Button = styled.button`
  padding: 12px 20px;
  border: none;
  border-radius: 12px;
  background: ${ATTENTION_BLUE};
  color: white;
  font-family: ${FONT_FAMILY.SEMI_BOLD};
  font-size: ${FONT_SIZE.MEDIUM};
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.2s ease;

  &:hover:not(:disabled) {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(18, 106, 243, 0.3);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  ${MEDIA.MOBILE} {
    font-size: ${FONT_SIZE.SMALL};
    padding: 10px 16px;
  }
`;

const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(8px); }
  to   { opacity: 1; transform: translateY(0); }
`;

export const AgentFinder__Result = styled.div`
  margin-top: 16px;
  width: 100%;
  padding: 16px 20px;
  background: ${BLUE1};
  border-radius: 12px;
  animation: ${fadeIn} 0.3s ease;
`;

export const AgentFinder__Reason = styled.p`
  color: ${BLUE3};
  font-family: ${FONT_FAMILY.REGULAR};
  font-size: ${FONT_SIZE.SMALL};
  margin: 0 0 12px 0;
  line-height: 1.5;
`;

export const AgentFinder__AgentLink = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: ${ATTENTION_BLUE};
  font-family: ${FONT_FAMILY.SEMI_BOLD};
  font-size: ${FONT_SIZE.MEDIUM};
  text-decoration: none;
  padding: 10px 20px;
  border: none;
  border-radius: 10px;
  background: white;
  transition: all 0.2s ease;
  cursor: pointer;

  &:hover {
    background: ${ATTENTION_BLUE};
    color: white;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(18, 106, 243, 0.3);
  }
`;

export const AgentFinder__Error = styled.p`
  color: #b75151;
  font-family: ${FONT_FAMILY.REGULAR};
  font-size: ${FONT_SIZE.SMALL};
  margin: 12px 0 0 0;
  text-align: center;
`;
